export function stickyHeader() {
	const header = document.getElementById("header");
	const spacer = document.getElementById("spacer");

	if (header !== null && spacer !== null) {
		// Create an intersection observer to watch the spacer element
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				if (!entry.isIntersecting) {
					header.classList.add("sticky");
				} else {
					header.classList.remove("sticky");
				}
			});
		}, {
			threshold: 0 // Trigger as soon as even one pixel is not visible
		});

		// Observe the spacer element
		observer.observe(spacer);
	}
}
